<py-responsive-table
  [tableClass]="tableClass"
  [entries]="assortment"
  [rowTemplate]="assortmentRowTemplate"
  [listItemTemplate]="assortmentListItemTemplate"
>
  <thead>
    <tr [ngClass]="{ 'font-secondary': pdpTypeSkuPicker }">
      <th scope="col">
        <span class="cx-visually-hidden">{{ 'product.dimensions_heading' | cxTranslate }}</span>
      </th>
      <th scope="col" *ngFor="let grammage of grammages || []">{{ grammage }}</th>
    </tr>
  </thead>
</py-responsive-table>
<ng-template #assortmentRowTemplate let-row>
  <tr>
    <th class="pl-3 font-secondary" scope="row">{{ row.key }}</th>
    <td *ngFor="let column of row.values">
      <span *ngFor="let icon of column.value">
        <i
          *ngIf="icon === 'REAMED'"
          nz-icon
          nzType="reamed"
          nzTheme="outline"
          class="pr-1"
          [ngbTooltip]="'product.reamed_tooltip' | cxTranslate"
        ></i>
        <i
          *ngIf="icon === 'UNREAMED'"
          nz-icon
          nzType="bulk_on_flex"
          nzTheme="outline"
          class="pr-1"
          [ngbTooltip]="'product.unreamed_tooltip' | cxTranslate"
        ></i>
        <i
          *ngIf="icon === 'BULKED'"
          nz-icon
          nzType="bulk"
          nzTheme="outline"
          class="pr-1"
          [ngbTooltip]="'product.bulked_tooltip' | cxTranslate"
        ></i>
      </span>
    </td>
  </tr>
</ng-template>
<ng-template #assortmentListItemTemplate let-row>
  <li [ngClass]="{ 'table-grey-list': pdpTypeSkuPicker }">
    <div class="p-3" [ngClass]="{ 'table-grey-list-header': !pdpTypeSkuPicker, 'list-header': pdpTypeSkuPicker }">
      <h3 class="h6">{{ row.key }}</h3>
    </div>

    <div
      class="p-2"
      [ngClass]="{ 'list-body p-3': pdpTypeSkuPicker, 'p-2': !pdpTypeSkuPicker }"
      *ngFor="let item of row.values || []"
    >
      <p class="d-flex justify-content-between" [ngClass]="{ 'font-secondary': pdpTypeSkuPicker }">
        <span>{{ item.grammage }}</span>
        <span [ngClass]="{ 'font-secondary': pdpTypeSkuPicker }" *ngFor="let icon of item.value">
          <i
            *ngIf="icon === 'REAMED'"
            nz-icon
            nzType="reamed"
            nzTheme="outline"
            class="pr-1"
            [ngbTooltip]="'product.reamed_tooltip' | cxTranslate"
          ></i>
          <i
            *ngIf="icon === 'UNREAMED'"
            nz-icon
            nzType="bulk_on_flex"
            nzTheme="outline"
            class="pr-1"
            [ngbTooltip]="'product.unreamed_tooltip' | cxTranslate"
          ></i>
          <i
            *ngIf="icon === 'BULKED'"
            nz-icon
            nzType="bulk"
            nzTheme="outline"
            class="pr-1"
            [ngbTooltip]="'product.bulked_tooltip' | cxTranslate"
          ></i>
        </span>
      </p>
    </div>
  </li>
</ng-template>
